import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorCircleIcon from '@mui/icons-material/Error';
import CancelCircleIcon from '@mui/icons-material/Cancel';

import baseStyles from '@ts-core/styles/baseStyles';

const useStyles = makeStyles((theme) => ({
  ...baseStyles(theme),
}));

const ScoreIcon = (props) => {
  const classes = useStyles();
  const { score } = props;
  if (score > 0) {
    return <CheckCircleIcon className={classes.optionPositive} />;
  }
  if (score === 0) {
    return <CancelCircleIcon className={classes.optionNeutral} />;
  }
  if (score < 0) {
    return <CancelCircleIcon className={classes.optionNegative} />;
  }
  return <ErrorCircleIcon className={classes.optionNone} />;
};

ScoreIcon.propTypes = {
  score: PropTypes.number,
};

ScoreIcon.defaultProps = {
  score: undefined,
};

export default ScoreIcon;
